module.exports = __webpack_public_path__ + "img/theme_one_slide.ec1f7a0e.svg";